import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation, useLink } from '@grandvisionhq/frk-routing';
import { Types } from '@grandvisionhq/graphql';
import { appendQueryParamToUrl } from '@grandvisionhq/utils';
import '../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { PaypalPaymentEventsProvider } from '../../../../context/Paypal/PaypalPaymentEventsContext.js';
import { useCreatePaypalPaymentEvents } from '../../../../hooks/paypal/use-create-paypal-payment-events.js';
import { useIsExpressPaypalSupportedForCart } from '../../../../hooks/use-is-express-paypal-supported.js';
import '../../../../models/adyen/payment-type.js';
import { ExpressPaymentMethod, PaymentMethod } from '../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../models/googlePay/types.js';
import '../../../../models/payment/types.js';
import '../../../../models/paypal/context.js';
import { PaypalActionButtonContainer } from './PaypalActionButtonContainer.js';

const PaypalExpressButton = ({ cartId , cartHash , isOrderInProgress =false , setIsOrderInProgress , onClickHandler  })=>{
    const [referenceId, setReferenceId] = React.useState(undefined);
    const [paymentToken, setPaymentToken] = React.useState(undefined);
    const { replace  } = useLocation();
    const expressCheckoutLink = useLink({
        route: 'express-overview',
        params: {
            type: ExpressPaymentMethod.PAYPAL,
            cartId,
            cartHash,
            referenceId: '',
            paymentToken: ''
        }
    });
    const { isExpressPaypalSupported , loading , error  } = useIsExpressPaypalSupportedForCart(cartId);
    // Need to redirect through an effect because onPaymentAuthorization is called inside
    // PayPal modal with a different context than the one we are using here. This means that
    // we won't have access to the paymentToken from initiatePaypalTransaction when we need to redirect.
    React.useEffect(()=>{
        if (referenceId && paymentToken && (expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.href)) {
            setIsOrderInProgress === null || setIsOrderInProgress === void 0 ? void 0 : setIsOrderInProgress(true);
            replace(appendQueryParamToUrl(expressCheckoutLink.href, {
                referenceId,
                paymentToken
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        replace,
        referenceId,
        paymentToken,
        expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.href
    ]);
    const handleOnClick = React.useCallback(()=>{
        onClickHandler && onClickHandler(PaymentMethod.PAYPAL);
    }, [
        onClickHandler
    ]);
    const paypalPaymentEvents = useCreatePaypalPaymentEvents({
        cartId,
        // Subscription is always disabled for express checkout
        hasSubscription: false,
        onPaymentAuthorization: setReferenceId,
        onPaymentTokenReceive: setPaymentToken,
        checkoutType: Types.CheckoutType.EXPRESS,
        onClick: handleOnClick
    });
    if (error || !isExpressPaypalSupported || loading) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PaypalPaymentEventsProvider, swcHelpers.extends({
        orderType: "regular"
    }, paypalPaymentEvents), /*#__PURE__*/ React.createElement(PaypalActionButtonContainer, {
        disabled: isOrderInProgress
    }));
};

export { PaypalExpressButton };
//# sourceMappingURL=PaypalExpressButton.js.map
